<template>
    <div class="row pt-3" style="border-top: 1px dashed rgba(106, 113, 133, 0.3);">
        <div class="col-sm-6">
            <div class="mb-3">
                <label>
                    <h6 class="f-w-700">{{ t('CondimentName') }}</h6>
                </label>
                <input v-model="compState.name" class="form-control" type="text" :placeholder="t('Name')" maxlength="32">
            </div>
        </div>
        <div class=" col-6">
            <label>
                <h6 class="f-w-700">{{ t('Price') }}</h6>
            </label>
            <div class="input-group">
                <input class="form-control" type="number" :placeholder="t('Threshold')" v-model="compState.price">
                <button class="btn btn-outline-secondary rounded-end-0" type="button" @click="priceDecrement">-</button>
                <button class="btn btn-outline-secondary rounded-start-0" type="button"
                    @click="priceIncrement">+</button>
            </div>
        </div>
        <div class=" col-sm-6">
            <div class="row h-100">
                <div class="col h-100">
                    <div class=" checkbox-checked d-flex h-100 align-items-center">
                        <div class="form-check ">
                            <input class="form-check-input" id="preset" type="checkbox" value=""
                                v-model="compState.preset">
                            <label class="form-check-label" for="preset">{{ t('Preset') }}</label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-sm-6">
            <div class="mb-3">
                <label>
                    <h6 class="f-w-700">{{ t('AlternativeDisplayLanguage') }}</h6>
                </label>
                <input class="form-control" type="text" :placeholder="t('AlternativeDisplayLanguage')"
                    v-model="compState.altLangText" maxlength="32" readonly data-bs-toggle="modal"
                    data-original-title="test" data-bs-target="#alt-lang-modal">
            </div>
        </div>
    </div>
    <condimentsAltLangModal @on-save="onEditAltLang" />
</template>

<script lang="ts" setup>
import { computed, reactive, watch, onMounted, defineAsyncComponent } from 'vue'
import { useCondimentStore } from '@/store/management/condimentsStore';
import type { Condiment } from '@/store/management/condimentsStore';

import { useI18n } from 'vue-i18n'
import { condimentsBasicLanguage } from '@/core/locales/condiments-language';

const { t } = useI18n({
  messages: condimentsBasicLanguage
})

const condimentsAltLangModal = defineAsyncComponent(() => import('@/components/managementPages/condimentsPage/condimentsAltLangModal.vue'))

const condimentStore = useCondimentStore()

onMounted(() => {
    if (tempActiveCondiment.value?.id) {
        compState.id = tempActiveCondiment.value.id
        compState.name = tempActiveCondiment.value.name
        compState.price = tempActiveCondiment.value.price
        compState.preset = tempActiveCondiment.value.preset
        compState.altLangText = altDisplayText(tempActiveCondiment.value.altDisplayLang)
    }
})

const compState = reactive({
    id: '',
    name: '',
    price: 0,
    preset: false,
    altLangText: ''
})

const activeCondiment = computed(() => {
    return condimentStore.getActiveCondiment
})

const tempActiveCondiment = computed(() => {
    return condimentStore.getTempActiveCondiment
})

const activeCondimentId = computed(() => {
    return condimentStore.getActiveCondimentId
})

const altDisplayText = (langList: String[]) => {
    if (langList) {
        return langList.filter(lang => lang !== '').join('|')
    }
    return ''
}

const onEditAltLang = () => {
    compState.altLangText = altDisplayText(tempActiveCondiment.value.altDisplayLang)
}

watch(activeCondimentId, (newVal) => {
    if (newVal) {
        const productGroup = activeCondiment.value
        compState.id = productGroup.id
        compState.name = productGroup.name
        compState.price = productGroup.price
        compState.preset = productGroup.preset
        compState.altLangText = altDisplayText(tempActiveCondiment.value.altDisplayLang)
    }
}, { immediate: true })

watch(compState, (newVal) => {
    condimentStore.setTempActiveCondiment({
        ...tempActiveCondiment.value,
        id: newVal.id,
        name: newVal.name,
        price: newVal.price,
        preset: newVal.preset,
    } as Condiment)
}, { deep: true });

const priceIncrement = () => {
    compState.price++
}

const priceDecrement = () => {
    if (compState.price > 0) {
        compState.price--
    }
}

</script>

<style scoped lang="scss">
.destination-container {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 1rem;
}

.hover-pointer {
    cursor: pointer;
}

.nav-link {
    color: var(--bs-heading-color);
}
</style>